var AxisDisplayMode = {
  ALL: {
    id: 'ALL',
    width: function width(axisWidth, numAxes) {
      return +axisWidth * +numAxes;
    },
    toString: function toString() {
      return 'ALL';
    }
  },
  NONE: {
    id: 'NONE',
    width: function width() {
      return 0;
    },
    toString: function toString() {
      return 'NONE';
    }
  },
  COLLAPSED: {
    id: 'COLLAPSED',
    width: function width(axisWidth) {
      var numAxes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return Math.min(+numAxes, 1) * +axisWidth;
    },
    toString: function toString() {
      return 'COLLAPSED';
    }
  }
};
export default AxisDisplayMode;